import applicationFilter from 'app/filters/application'
import UserRole from 'app/enums/UserRole'

import zipObject from 'lodash/zipObject'

export default class Application {

    static MIJN_AVECO = 'MIJN_AVECO';
    static MONITOR = 'MONITOR';
    static VELDWERKWINKEL = 'VELDWERKWINKEL';
    static LOGGERS = 'LOGGERS';
    static VELDWERKDATA = 'VELDWERKDATA';

    static options(){

        const keys = Object.keys(Application);
        return zipObject(keys, keys.map(applicationFilter));
    }

    static applicationRoles()  {
        return {
            MIJN_AVECO: [UserRole.USER, UserRole.ADMIN, UserRole.ADVISOR],
            MONITOR: [UserRole.USER, UserRole.ADMIN, UserRole.CONTRACTOR, UserRole.SUPPLIER, UserRole.SUPPLIER_ALTITUDE, UserRole.SUPPLIER_VIBRATION, UserRole.RESIDENT],
            VELDWERKWINKEL: [UserRole.USER, UserRole.ADMIN, UserRole.WORKER, UserRole.ADVISOR, UserRole.ADVISOR_EXTERNAL, UserRole.CONTRACTOR],
            LOGGERS: [UserRole.USER, UserRole.ADMIN, UserRole.ADVISOR],
            VELDWERKDATA: [UserRole.USER, UserRole.ADMIN, UserRole.ADVISOR_EXTERNAL],
        }
    }
}
